export default {"src":"/_next/static/media/diversity.cdd6dabf.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};